module.exports = __webpack_public_path__ + "static/media/edit.a7108f98.png";